/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
// import classNames from "classnames";

// const PercentageIndicator = ({ percentage, activeIndex, totalDots = 3 }) => (
//   <div className="flex items-center gap-2 p-2 rounded-lg bg-blue-50">
//     {/* Percentage Box */}
//     <div className="px-4 py-2 bg-white rounded-lg shadow text-2xl font-bold">
//       {percentage}%
//     </div>

//     {/* Status Dots */}
//     <div className="flex flex-col gap-2">
//       {Array.from({ length: totalDots }).map((_, index) => (
//         <span
//           key={`dot-${index}`}
//           className={classNames(
//             "w-3 h-3 rounded-full border border-gray-400",
//             index === activeIndex ? "bg-lime-400" : "bg-gray-200"
//           )}
//         />
//       ))}
//     </div>
//   </div>
// );

// PercentageIndicator.propTypes = {
//   percentage: PropTypes.number.isRequired,
//   activeIndex: PropTypes.number.isRequired,
//   totalDots: PropTypes.number,
// };

// export default PercentageIndicator;

import "./PercentageIndicator.css"; // Import the CSS file

const PercentageIndicator = ({ percentage, activeIndex }) => {
  return (
    <div className="indicator-card">
      {/* Percentage */}
      <div className="percentage-text">
        {percentage}
        <span className="percentage-symbol">%</span>
      </div>

      {/* Indicators */}
      <div className="indicator-dots">
        {[1, 2,3].map((index) => (
          <div
            key={index}
            className={activeIndex === index ? `dot-${index}` : "dot"}
          />
        ))}

      </div>
    </div>
  );
};

PercentageIndicator.propTypes = {
  percentage: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  totalDots: PropTypes.number,
};

export default PercentageIndicator;